import { useTheme } from 'next-themes';
import { useSyncedUserPreference } from '@reflex/ui/client/user-preferences';
import { useNavStyle } from '@/components/layout/NavBar/useNavStyle';
import { useSessionSort } from '@/components/agent/useSessionSort';

/** Sync browser-backed presentation settings to the signed-in account. */
export function useAccountPreferencesSync(): void {
  const [navigation, setNavigation] = useNavStyle();
  const [sessionOrder, setSessionOrder] = useSessionSort();
  const { theme, setTheme } = useTheme();
  const appearanceMode =
    theme === 'light' || theme === 'dark' || theme === 'system' ? theme : 'system';

  useSyncedUserPreference('navigation', navigation, setNavigation);
  useSyncedUserPreference('sessionOrder', sessionOrder, setSessionOrder);
  useSyncedUserPreference('appearanceMode', appearanceMode, setTheme, {
    enabled: theme !== undefined,
  });
}
